
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reciters/[reciterId]/[chapterId]",
      function () {
        return require("private-next-pages/reciters/[reciterId]/[chapterId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reciters/[reciterId]/[chapterId]"])
      });
    }
  